<template>
  <div class="privacy-page">
    <div class="privacy-page__backdrop" aria-hidden="true"></div>
    <div class="privacy-page__inner">
      <header class="privacy-page__header">
        <button type="button" class="privacy-page__back" @click="goBack">
          <i class="fas fa-arrow-left"></i>
          返回
        </button>
        <h1 class="privacy-page__title">idoing 用户协议</h1>
        <p class="privacy-page__meta">
          <span>更新日期：2026 年 05 月 17 日</span>
          <span class="privacy-page__meta-sep">·</span>
          <span>生效日期：2026 年 05 月 17 日</span>
        </p>
      </header>

      <article class="privacy-doc">
        <p class="privacy-doc__lead">欢迎您使用 idoing 相关服务。</p>
        <p>
          「idoing」指 idoing 产品运营方及其关联方（以下简称「我们」）合法拥有并运营的 idoing
          客户端应用程序和官方网站，也包括以 idoing 名义提供给第三方平台和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）等为用户提供服务的产品。
        </p>

        <nav class="privacy-doc__toc">
          <p class="privacy-doc__toc-title">本协议目录：</p>
          <ol>
            <li><a href="#section-1">1. 导言</a></li>
            <li><a href="#section-2">2. idoing 产品及服务</a></li>
            <li><a href="#section-3">3. idoing 账号</a></li>
            <li><a href="#section-4">4. 用户个人信息保护</a></li>
            <li><a href="#section-5">5. 用户行为规范</a></li>
            <li><a href="#section-6">6. 知识产权</a></li>
            <li><a href="#section-7">7. 用户的违约及处理</a></li>
            <li><a href="#section-8">8. 责任范围与责任限制</a></li>
            <li><a href="#section-9">9. 未成年人使用条款</a></li>
            <li><a href="#section-10">10. 费用</a></li>
            <li><a href="#section-11">11. 协议的成立、终止及争议解决</a></li>
            <li><a href="#section-12">12. 其他</a></li>
          </ol>
        </nav>

        <section id="section-1" class="privacy-doc__section">
          <h2>1. 导言</h2>
          <p>
            1.1 本协议由我们与同意遵照本协议使用 idoing 相关服务的用户（以下简称「您」）共同缔结。请您注意，我们已经发布的、后续可能发布的、或不时修改的与
            idoing 有关的其他相关协议、活动规则、公告说明、站内信通知等（合称「平台规则」）均构成本协议不可分割的组成部分，与本协议具有同等法律效力。对于后续我们发布的或修改的平台规则，我们将在为您提供相应服务时向您特别提示或以适当的方式通知您。如果您不接受或不理解本协议任一修改后的条款的，您可以通过
            idoing 平台客服进行咨询，如您咨询后仍不同意相关变更，您应当于变更事项确定的生效之日起停止使用 idoing 平台的功能与服务，如您在变更事项生效后仍继续使用，则视为您已充分理解并接受已生效的变更事项。
          </p>
          <p>
            1.2 为使用 idoing 相关服务，请您务必审慎阅读、充分理解《idoing 用户协议》（以下简称「本协议」）的各项条款，特别是限制和/或免除责任条款、隐私保护政策、账号规则、法律适用和争议解决条款（包括管辖条款）。
          </p>
          <p>
            1.3 idoing 的主要服务人群为成年人。如您未满 18 周岁，请您务必在监护人陪同下仔细阅读并充分理解本协议，尤其是其中未成年人相关的使用条款，并在征得监护人同意后，方可使用
            idoing。
          </p>
          <p>
            1.4 您通过网络页面点击注册或实际使用 idoing 相关服务的行为即视为您已充分阅读、理解并接受本协议的全部内容，本协议将对您产生法律约束力。若您不同意或不理解本协议的任何内容，请不要执行签约动作。
          </p>
          <p>
            1.5 如您对本协议内容有任何疑问、意见或建议，您可通过发送邮件至
            <a :href="contactMailto">{{ contactEmail }}</a> 与我们联系。
          </p>
        </section>

        <section id="section-2" class="privacy-doc__section">
          <h2>2. idoing 产品及服务</h2>
          <p>
            2.1 本协议适用于您访问和使用 idoing 所有形态产品所提供的 AI 内容生成功能与服务，包括但不限于模型训练、内容生成、信息发布、互动交流、搜索查询等多种服务。
          </p>
          <p>
            2.2 idoing 旨在提供文生图、文生视频、图生视频等人工智能应用及相关功能，旨在启发画师、设计师、艺术家等视觉内容创作者的灵感并辅助完成创作，也适用于大众用户的个性化
            AI 内容创作。
          </p>
          <p>
            2.3 我们许可您一项个人的、可撤销的、不可转让的和非独占的合法使用 idoing 的权利，本协议未明示授权的其他一切权利仍由我们保留。除非得到我们事先明示的书面授权，否则您将不得以任何未经授权的形式使用
            idoing，包括但不限于复制、传播、改编、爬虫、垂直搜索、镜像或交易等。
          </p>
        </section>

        <section id="section-3" class="privacy-doc__section">
          <h2>3. idoing 账号</h2>
          <p>
            您理解并确认，在您开始注册使用 idoing 平台服务之前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备与您行为相适应的民事行为能力，请您在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后方可注册使用
            idoing 平台服务，您及您的监护人应承担因您的注册和使用行为而导致的一切后果。
          </p>

          <h3>3.1 账号注册</h3>
          <p>
            3.1.1 您在使用 idoing 平台服务前需通过您的实名手机号或通过 idoing 平台认可的第三方账号（如微信账号、QQ
            账号等）进行注册。您在注册或使用 idoing 平台服务时可能需要提供一些必要的信息，为保证您享用的平台服务安全有效且不断优化，您同意授权我们对您的必要个人信息进行验证和合理使用。您须保证所填写及所提供的资料真实、准确、完整，否则可能无法使用
            idoing 平台服务，或在使用过程中受到限制，甚至影响您是否能够使用 idoing 平台的特定功能。对于因您提供的信息不真实、不准确或不完整导致的责任和损失由您承担。
          </p>
          <p>
            3.1.2 您注册成功的账号仅可供您注册时确认的单一使用主体自身正当使用，不得用于违法违规、损害他方利益等用途；不得恶意批量注册账号；未经我们书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果我们发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，我们有权立即暂停或终止向该注册账号提供服务，并有权永久禁用该账号。
          </p>
          <p>
            3.1.3 您可以在非登录状态下使用 idoing，但无法体验产品全部功能与服务。在使用某些功能和/或某些单项服务前，如 AI
            内容生成、信息发布、互动交流等，您必须完成账号注册或登录，并按照国家相关法律法规的要求完成真实身份信息认证——收集手机号码是履行国家相关法律法规对网络实名制（真实身份信息认证）要求所需的必要信息，如果您拒绝在注册/登录环节提供手机号码，我们可能无法为您提供
            AI 内容生成、信息发布、互动交流相关功能和服务。
          </p>
          <p>
            3.1.4 若您提供任何违法、不道德或我们认为不适合在 idoing 平台上展示的资料，或是我们有理由怀疑您的资料属于自动程序或恶意操作，我们有权暂停或终止您的账号，并拒绝您于现在和未来使用
            idoing 平台服务之全部或任何部分。
          </p>
          <p>
            3.1.5 我们及 idoing 平台无须对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料的责任。
          </p>
          <p>
            3.1.6 您有责任自行负责保管账号的用户名和密码/验证码等信息，否则因该等事项引发的法律责任由用户自行承担。凡使用 idoing
            平台服务登录账号和登录凭证的行为，视为您本人的操作，操作所产生的电子信息记录均为 idoing 平台服务用户行为的有效凭据。
          </p>
          <p>3.1.7 在需要终止使用 idoing 平台账号服务时，理解并同意以下要求或条件的，您可以申请注销您的 idoing 平台账号：</p>
          <ul>
            <li>（1）您仅能申请注销您本人的账号，请发送邮件至 <a :href="contactMailto">{{ contactEmail }}</a> 与我们联系进行账号注销；</li>
            <li>（2）您仍应对您在注销账号前使用 idoing 的行为承担相应责任；</li>
            <li>（3）账号注销删除后，我们将对账号内的信息做删除或者匿名化等处理，但法律法规或相关规范对信息保存时间或处理方式另有规定的除外。账号注销删除后，您将无法再使用该账号进行登录，也无法找回账号相关的任何内容或信息。</li>
          </ul>
          <p>
            3.1.8 根据相关法律法规要求，如您的账号连续六个月以上未登录，则我们将有权冻结或收回您的账号。账号被冻结或收回后，该账号将无法再被登录并使用。账号回收后，账号下保存的信息和使用记录也将无法恢复。在冻结或收回您的账号前，我们将以适当的方式向您作出提示，如您在收到相关提示后仍未按提示进行操作，我们将冻结或收回账号。
          </p>

          <h3>3.2 用户账号安全</h3>
          <p>完成 idoing 账号的注册后，保护账号安全是您的责任。您同意：</p>
          <p>
            3.2.1 您应对所有使用您的账号的活动负完全的责任，包括但不限于您在 idoing 平台中进行的任何数据修改等行为。您应高度重视对账号与验证码的保密，在任何情况下不向他人透露账号及验证码。您的
            idoing 平台账号遭到未获授权的使用，或者发生其它任何安全问题时，您应立即通知我们，除我们存在法定过错外，因延迟通知可能给您造成的损失我们不承担任何责任。
          </p>
          <p>3.2.2 如果您未保管好自己的账号和验证码，因此而产生的任何损失或损害，我们无法也不承担任何责任。</p>
          <p>
            3.2.3 您有责任维护账号、验证码的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任。如果您未保管好自己的账号和验证码而对您、我们或第三方造成的损害，您将负全部责任。
          </p>
          <p>
            3.2.4 您不得以任何形式擅自转让或授权他人使用您的账户，因您主动泄露、出借账户信息或因您遭受他人攻击、诈骗等行为导致的损失及后果，idoing
            将不承担任何责任，您可以通过司法、行政等救济途径向侵权行为人追偿。
          </p>

          <h3>3.3 统一账号服务</h3>
          <p>
            3.3.1 如无特别说明，idoing 各关联平台均使用统一的 idoing 账号服务，您注册的 idoing 账号同时通用于 idoing
            的各关联平台，您在 idoing 账号下发布的内容也会在 idoing 的各关联平台中同步。您以 idoing
            账号登录并使用关联平台相关服务的，应同时受本协议和关联版本用户协议及平台规则约束（如有）。如关联平台的用户协议及平台规则与本协议不一致的，优先适用关联平台的用户协议及平台规则。
          </p>
          <p>
            3.3.2 为提高您生成及发布内容的发布效率及曝光量，您同意您在 idoing 账号下发布的全部内容均授权我们以您的账号自动同步至我们运营的其他软件及网站，您的
            idoing 账号头像、昵称等公开信息可能会一并同步。
          </p>
          <p>
            3.3.3 为维护良好的平台秩序及氛围，我们可能会对 idoing 各关联平台采取协同的管理手段。例如：如您在 idoing
            中因违反法律法规或本协议约定的行为被采取处罚措施，您对关联平台的相关服务使用也可能受到处罚措施的影响，反之亦然。
          </p>
        </section>

        <section id="section-4" class="privacy-doc__section">
          <h2>4. 用户个人信息保护</h2>
          <p>
            4.1 尊重用户隐私并保护您的个人信息安全是我们的一贯态度，我们将会采取合理的措施保护您的个人信息与隐私。我们承诺，除非获得用户同意，我们不会收集、使用其提供服务所必需以外的用户个人信息或者将信息用于提供服务之外的目的。在遵守本协议项下特别约定的个人信息保护及隐私政策外，我们希望您认真并完整阅读我们特别针对平台而制定并适时发布的
            <router-link to="/privacy">idoing 隐私政策</router-link>，这将更有助于保障您的个人信息。
          </p>
          <p>
            您知悉并同意，为方便您使用 idoing 相关服务，我们有权在遵守法律法规的前提下，以明示的方式获取、使用、储存和分享您的个人信息。我们不会在未经您授权时，公开、编辑或透露您的个人信息及您保存在
            idoing 的非公开内容。
          </p>
          <p>
            您知悉并同意，我们有权通过 cookie 等技术收集您的产品或服务使用、行为数据，并在经过数据脱敏使之不再指向或关联到您个人的身份信息时，自由使用脱敏后的纯商业数据。
          </p>
          <p>
            您可以联系人工客服或发送电子邮件至 <a :href="contactMailto">{{ contactEmail }}</a>
            申请查阅、复制、更正、补充或删除个人信息，过程中需进行身份验证，核验无误后，我们承诺在合理期限内（例如 30 个工作日）完成核查和处理。
          </p>
          <p>
            4.2 我们将运用各种安全技术和程序、建立完善的管理制度来保护您的个人信息，防止您的信息被不当使用或遭受未经授权的访问、使用或披露。
          </p>
          <p>4.3 未经您的同意，我们不会向其他任何我们、组织和个人披露您的个人信息，除非：</p>
          <ul>
            <li>（1）相关法律法规或司法机关、行政机关要求；</li>
            <li>（2）为完成合并、分立、收购或资产转让而转移；</li>
            <li>（3）为提供您要求的服务所必须；</li>
            <li>（4）依照《隐私政策》或其他协议规则可以转移或披露给第三方的情形。</li>
          </ul>
        </section>

        <section id="section-5" class="privacy-doc__section">
          <h2>5. 用户行为规范</h2>
          <p>
            5.1 您保证合理地使用 idoing 相关服务，并接受本协议和我们适时制定并发布的其他政策、规则、公告声明。您应对您使用 idoing
            相关服务的行为负责，除非法律允许或者经我们事先书面许可，您使用 idoing 平台相关服务不得具有下列行为：
          </p>
          <p>
            5.1.1 使用未经我们授权或许可的任何插件、外挂、系统或第三方工具对 idoing 相关服务的正常运行进行干扰、破坏、修改或施加其他影响。
          </p>
          <p>5.1.2 利用或针对 idoing 相关服务进行任何危害计算机网络安全的行为，包括但不限于非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动，以及利用
            idoing 发表、传送、传播、储存危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容等。</p>
          <p>
            如果我们有理由认为您的行为违反或可能违反上述约定的，我们可独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。
          </p>
          <p>
            5.1.3 信息内容规范：为了营造良好网络生态，保障公民、法人和其他组织的合法权益，维护国家安全和公共利益，我们将根据相关法律法规，自觉践行社会主义核心价值观，营造清朗的网络空间，并开展的弘扬正能量、处置违法和不良信息等相关活动。用户亦承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等「七条底线」。
          </p>
          <p>
            5.2 您同意，您从我们或其他用户处下载、访问或使用的任何内容均由您自行承担使用风险，并受这些条款和/或此类内容随附条款的约束。未经我们书面许可，任何用户、第三方不得以任何方式直接或间接盗取
            idoing 相关服务的模型、图片、文章等信息内容。
          </p>
          <p>
            5.3 您应尊重隐私与道德，注意保护数据安全，不得输入、分享任何未经授权的个人信息、保密信息及未经授权的其他类型的信息；您应尊重他人合法权益，确保您输入的内容均合法合规、为您本人所有或已获得合法授权。
          </p>
          <p>
            5.4 为提醒用户相关内容系由人工智能生成合成，我们将根据法律法规要求在人工智能生成合成内容中添加人工智能生成合成标识。请您不得以任何方式遮挡、涂抹、修改或删除我们对
            AI 内容添加的标识。
          </p>
          <p>5.5 您可以向我们申请提供没有添加显式标识的生成合成内容，并应自行在使用该生成合成内容的过程中以其他显著方式进行标识。</p>
          <p>
            5.6 您制作、评论、发布、传播的信息和内容应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等「七条底线」要求，否则我们有权立即采取包括删除内容和账号等相应处理措施。您同意并承诺不制作、复制、发布、传播违法违规信息内容。
          </p>
          <p>5.7 我们设立了投诉举报渠道，您可按照我们公示的投诉举报入口对各类违法违规行为、违法有害信息采取投诉举报，我们将及时受理和处理您的投诉举报。</p>
        </section>

        <section id="section-6" class="privacy-doc__section">
          <h2>6. 知识产权</h2>
          <p>
            6.1 您理解并同意，idoing 平台提供的服务中包含的任何编码、商标、服务标志、商号、图形、美术品、照片、肖像、文字内容、音频、视频、按钮图标以及计算机软件、标识、数码下载、数据汇编等都是我们或其内容提供者的财产，受中华人民共和国著作权、商标权和其他财产所有权相关法律法规的保护，您不得进行任何侵犯我们或任何第三方知识产权或其他权益的行为。
          </p>
          <p>
            6.2 您理解并同意，除非另有约定，您通过 idoing 平台上传、发布的用户内容的所有权、知识产权及其他法律权利，归您或您的许可方所有。为使用户内容得到更好的分享及推广，提高其传播价值及影响力，您同意和/或确保实际权利人同意：
          </p>
          <p>
            6.2.1 您承诺在使用 idoing 相关服务时上传、发布的内容均由您原创或已获合法授权，不存在侵犯第三方知识产权或权利的行为。您使用 idoing
            平台在线生成内容的所有权归属您本人所有；相关生成内容的知识产权等财产性权利归属您或相关知识产权人所有。
          </p>
          <p>6.2.2 在您的授权下，我们有权在必要时以自己的名义或委托专业第三方，对侵犯您上传发布的享有知识产权的内容进行代维权。</p>
          <p>
            6.2.3 您对您在 idoing 平台上发布或以其他方式提供的内容拥有所有权、控制权和责任。您的内容不得违反任何本协议的内容、适用法律和法规，也不得侵犯或盗用任何个人或实体的任何权利。
          </p>
          <p>
            6.2.4 您使用 idoing 相关服务生成图片等内容时，在生成工具的交互界面、生成图片/视频显示区域会带有「内容由 idoing 生成」字样的品牌水印，您下载图片/视频时可选择生成
            AI 品牌水印样式并保存。
          </p>
          <p>
            6.2.5 您应当善意地将本服务作为辅助创作的工具，如您拟就生成内容进行公开发行传播或商业化使用时，您应当对生成内容及使用行为是否符合法律法规规定进行必要审查，必要时还应当寻求专业法律意见。
          </p>
          <p>
            6.2.6 为持续改善 idoing 为您提供的各项服务，对于您输入、生成及上传到 idoing
            的任何文件或内容，您明确授予我们一项全球范围内、永久、免费、非独家、可多层次再许可的权利，以在互联网当前或未来的媒体中以任何形式使用、展示、下载和/或分发上述文件或内容及创建的衍生作品。如果您不希望我们用于前述目的，您可通过意见反馈相关页面或发送邮件至
            <a :href="contactMailto">{{ contactEmail }}</a> 联系我们。
          </p>
          <p>6.3 当内容包含合理且惯常的许可声明（例如开源许可）时，此类内容在进一步访问、分发或使用时应遵守该许可的条款。</p>
        </section>

        <section id="section-7" class="privacy-doc__section">
          <h2>7. 用户的违约及处理</h2>
          <p>
            7.1 针对您违反本协议或其他服务条款的行为，我们有权独立判断并视情况采取预先警示、拒绝发布、立即停止传输信息、删除内容或评论、短期禁止发布内容或评论、限制账号部分或者全部功能直至终止提供服务、永久关闭账号等措施，对于因此而造成您无法正常使用账号及相关服务、无法正常获取您账号内资产或其他权益等后果，我们不承担任何责任。
          </p>
          <p>
            7.2 我们尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用 idoing
            服务时上传的文字、图片、模型或使用其他用户提供的模型生成的文字、图片、视频等内容时不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。
          </p>
          <p>
            7.3 您对您使用 idoing 服务的行为全权负责，若因您使用（或无法使用）服务而产生的所有赔偿责任和费用（包括律师费），您应当对我们和相关方进行赔偿，除非索赔直接源于
            idoing 的欺诈、重大过失或故意犯罪行为，则此赔偿责任不适用。
          </p>
          <p>7.4 您同意我们有权作为独立的第三方，根据我们所了解到的争议事实并依据 idoing 争议解决规则，以普通人的注意义务程度，独立的作出调查处理决定。</p>
          <p>7.5 如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、冻结、终止/中止/限制使用账号等功能、解除或终止本协议，或提出损害赔偿等措施。</p>
        </section>

        <section id="section-8" class="privacy-doc__section">
          <h2>8. 责任范围与责任限制</h2>
          <p>8.1 我们的服务按现状和可得到的状态提供，我们在此明确声明对服务不作任何明示或暗示的保证，包括但不限于服务的可适用性、无疏漏、持续性、准确性、可靠性、或适用于某一特定用途。</p>
          <p>
            8.2 鉴于现阶段科学技术的局限性以及人工智能生成技术原理，我们难以保证生成内容的真实性、准确性、可靠性、独特性。相同或相似输入内容的生成结果可能存在不确定性，因此我们对生成内容不作任何保证。您应当对生成内容自行加以客观、审慎的判断和验证，您根据生成内容所作出的任何判断或者据此作出的后续相关操作行为所带来的后果和责任均由您自行承担。
          </p>
          <p>8.3 我们依照法律规定履行基础保障义务，但对于不可抗力因素、公共服务因素或第三人因素等导致的协议履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我们不承担责任。</p>
          <p>8.4 我们对于您自 idoing 获得的所有他人、第三方的信息、内容或者广告宣传等任何资讯，除法律明确规定外，不保证真实、准确和完整性。</p>
          <p>8.5 我们依据相关法律法规、本协议及平台规则约定，获得审核、处理违法违规内容的权利，但该权利不构成我们的义务或承诺，我们不能保证及时发现违法行为或进行相应处理。</p>
          <p>8.6 除有效的司法判决外，我们不对 idoing 相关服务引发的任何间接的、偶然的、特殊的或惩罚性的损害赔偿承担责任。</p>
        </section>

        <section id="section-9" class="privacy-doc__section">
          <h2>9. 未成年人使用条款</h2>
          <p>
            9.1 若您是未满 18 周岁的未成年人，您应在您的监护人监护、指导下并获得监护人同意的情况下，认真阅读并同意本协议后，方可使用 idoing
            相关服务。若您未取得监护人的同意，监护人可以通过平台公示渠道通知平台处理相关账号，平台有权对相关账号的功能、使用进行限制。
          </p>
          <p>9.2 我们重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并应在取得监护人的同意以及在监护人指导下正确使用 idoing 相关服务。</p>
          <p>9.3 未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而可能导致的全部法律责任。</p>
          <h3>9.4 未成年人用户特别提示</h3>
          <p>9.4.1 未成年人使用 idoing 相关服务应该在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯。</p>
          <p>青少年用户必须遵守《全国青少年网络文明公约》。</p>
          <p>9.4.2 为更好地保护未成年人隐私权益，我们特别提醒您慎重发布包含未成年人素材的内容，一经发布，即视为您已获得权利人同意在 idoing 相关服务展示未成年人的肖像、声音等信息。</p>
          <h3>9.5 监护人特别提示</h3>
          <p>如您的被监护人使用 idoing 相关服务的，您作为监护人应指导并监督被监护人的注册和使用行为，如您的被监护人申请注册平台账号，我们将有权认为其已取得您的同意。</p>
        </section>

        <section id="section-10" class="privacy-doc__section">
          <h2>10. 费用</h2>
          <p>
            我们为 idoing 相关服务付出了大量成本，我们向您提供的服务可能包括免费服务或付费服务，具体以平台页面展示为准，您可以根据需要选择免费服务或付费服务。您理解并同意，我们可能基于业务发展的需要调整服务的收费标准和方式，也可能会对部分免费服务开始收费，我们将通过平台页面进行通知或公示。为清楚起见，我们通过
            idoing 平台提供的免费服务不应视为放弃后续收费的权利。
          </p>
        </section>

        <section id="section-11" class="privacy-doc__section">
          <h2>11. 协议的成立、终止及争议解决</h2>
          <p>11.1 本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。</p>
          <p>11.2 您有权通过注销账户、停止使用并明示不愿接受变更事项、明示不愿继续使用 idoing 平台服务等方式终止本协议。</p>
          <p>11.3 出现您违反本协议约定、发布虚假信息或侵犯他人合法权益等情形时，我们有权单方面终止本协议。</p>
          <p>11.4 您理解并同意，本协议终止并不能当然地免除您在本协议有效期间应履行的相关义务，如您在协议终止前存在违约行为，我们在协议终止后仍有权追究您的违约责任。</p>
          <p>11.5 本协议的签署地点为 idoing 平台运营主体所在地，若您与我们发生任何争议，双方应尽量友好协商解决，协商不成，您同意应将争议提交至有管辖权的人民法院诉讼解决。</p>
        </section>

        <section id="section-12" class="privacy-doc__section">
          <h2>12. 其他</h2>
          <p>
            12.1 为给您提供更好的服务或因国家法律法规、政策调整、技术条件、产品功能等变化需要，我们会适时对本协议进行修订，修订内容构成本协议的组成部分。本协议更新后，我们会在
            idoing 平台发出更新版本，并在更新后的条款生效前通过公告或其他适当的方式提醒您更新的内容，以便您及时了解本协议的最新版本。如您继续使用 idoing
            相关服务，即表示您已同意接受修订后的本协议内容；如果您不接受修改后的本协议内容，则您应停止使用 idoing 相关服务。
          </p>
          <p>12.2 本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。</p>
          <p>12.3 您和我们均是独立的主体，在任何情况下本协议不构成我们对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。</p>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  data() {
    return {
      contactEmail: 'pluskeji@126.com'
    }
  },
  computed: {
    contactMailto() {
      return `mailto:${this.contactEmail}`
    }
  },
  mounted() {
    document.title = 'idoing 用户协议'
  },
  beforeDestroy() {
    document.title = 'idoing'
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.go(-1)
      else this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.privacy-page {
  position: relative;
  height: 100vh;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  background: #0e1014;
  color: rgba(255, 255, 255, 0.82);
}
.privacy-page__backdrop {
  pointer-events: none;
  position: fixed;
  inset: 0;
  z-index: 0;
  background:
    radial-gradient(ellipse 120% 80% at 50% -20%, rgba(56, 100, 180, 0.16) 0%, transparent 55%),
    linear-gradient(180deg, #0e1014 0%, #161922 45%, #12141a 100%);
}
.privacy-page__inner {
  position: relative;
  z-index: 1;
  max-width: 860px;
  margin: 0 auto;
  padding: 32px 20px 64px;
}
.privacy-page__header {
  margin-bottom: 28px;
}
.privacy-page__back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding: 8px 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.privacy-page__back:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}
.privacy-page__title {
  margin: 0 0 10px;
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fff;
}
.privacy-page__meta {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.42);
}
.privacy-page__meta-sep {
  margin: 0 8px;
}
.privacy-doc {
  padding: 28px 24px 36px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.02);
  line-height: 1.85;
  font-size: 14px;
}
.privacy-doc__lead {
  margin-top: 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.92);
}
.privacy-doc p {
  margin: 0 0 14px;
}
.privacy-doc a {
  color: #7dd3fc;
  text-decoration: none;
}
.privacy-doc a:hover {
  text-decoration: underline;
}
.privacy-doc__toc {
  margin: 24px 0 28px;
  padding: 18px 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.privacy-doc__toc-title {
  margin: 0 0 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
}
.privacy-doc__toc ol {
  margin: 0;
  padding-left: 20px;
}
.privacy-doc__toc li {
  margin: 6px 0;
}
.privacy-doc__section {
  margin-top: 32px;
  scroll-margin-top: 24px;
}
.privacy-doc__section h2 {
  margin: 0 0 14px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
.privacy-doc__section h3 {
  margin: 20px 0 10px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}
.privacy-doc ol,
.privacy-doc ul {
  margin: 0 0 14px;
  padding-left: 22px;
}
.privacy-doc li {
  margin: 8px 0;
}
@media (max-width: 640px) {
  .privacy-page__inner {
    padding: 20px 14px 48px;
  }
  .privacy-doc {
    padding: 20px 16px 28px;
  }
}
</style>
